import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Frame from './components/Frame';


function App() {



  return (
    <Router>
      <div className="mm-wrapper">
        <div
          id="page"
          className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200"
        >
          <div className="pt-20"> {/* Padding for fixed navbar */}
            <Routes>
              <Route path="/" element={<Frame />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;